declare namespace $ {

	type $shm_tests_benchmark_table__results_shm_tests_benchmarks_1 = $mol_type_enforce<
		ReturnType< $shm_tests_benchmarks['results'] >
		,
		ReturnType< $shm_tests_benchmark_table['results'] >
	>
	type $mol_paragraph__title_shm_tests_benchmarks_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $shm_tests_benchmarks extends $mol_page {
		body_rows( ): readonly($mol_view)[]
		results( ): readonly(any)[]
		display_title( ): string
		title( ): string
		body( ): ReturnType< $shm_tests_benchmarks['body_rows'] >
		Table( ): $shm_tests_benchmark_table
		Empty( ): $mol_paragraph
	}
	
}

//# sourceMappingURL=benchmarks.view.tree.d.ts.map